var _path, _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFileSmall = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#85C7F6",
    fillRule: "evenodd",
    d: "M14 3.978L17.742 8h-3.028C14.32 8 14 7.619 14 7.15V3.978zm5.741 3.35l-4.445-5c-.189-.209-.458-.328-.74-.328h-8C5.146 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.556 22h10.888C18.854 22 20 20.878 20 19.5V8c0-.249-.092-.488-.259-.672z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    width: 16,
    height: 20,
    x: 4,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14 3.978L17.742 8h-3.028C14.32 8 14 7.619 14 7.15V3.978zm5.741 3.35l-4.445-5c-.189-.209-.458-.328-.74-.328h-8C5.146 2 4 3.122 4 4.5v15C4 20.878 5.146 22 6.556 22h10.888C18.854 22 20 20.878 20 19.5V8c0-.249-.092-.488-.259-.672z",
    clipRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file_small.2921c756.svg";
export { ForwardRef as ReactComponent };